import { debounce } from "lodash-es";
import REG from "../reg";
export function compatibleResize(handler) {
    var ua = window.navigator.userAgent;
    // iOS下Chrome浏览器resize事件触发过早
    if (REG.iPhone.test(ua) && /CriOS/.test(ua)) {
        return debounce(handler, 50);
    }
    return handler;
}
